//outsource
import { Button } from "antd";
//components

const ConsultationBtn = ({ mobile, setOpen }) => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX -------------------------
  // -------------------------- FUNCTION ---------------------
  // -------------------------- EFFECT ------------------------
  // -------------------------- RENDER ------------------------
  // -------------------------- MAIN ---------------------------
  return (
    <Button
      className="booking-btn"
      type="primary"
      style={{ fontSize: mobile ? "small" : "medium" }}
      onClick={() => setOpen(true)}
    >
      FREE CONSULTATION
    </Button>
  );
};
export default ConsultationBtn;
